import { render, staticRenderFns } from "./WhatsappPollList.vue?vue&type=template&id=2b3512f0"
import script from "./WhatsappPollList.vue?vue&type=script&lang=js"
export * from "./WhatsappPollList.vue?vue&type=script&lang=js"
import style0 from "./WhatsappPollList.vue?vue&type=style&index=0&id=2b3512f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports